export const GUIDES = [
  {
    slug: 'how-to-play',
    titleKey: 'guide_howto_title',
    excerptKey: 'guide_howto_excerpt',
    paragraphs: ['guide_howto_p1', 'guide_howto_p2', 'guide_howto_p3'],
  },
  {
    slug: 'tips-to-guess-faster',
    titleKey: 'guide_tips_title',
    excerptKey: 'guide_tips_excerpt',
    paragraphs: ['guide_tips_p1', 'guide_tips_p2', 'guide_tips_p3'],
  },
  {
    slug: 'categories-and-themes',
    titleKey: 'guide_categories_title',
    excerptKey: 'guide_categories_excerpt',
    paragraphs: ['guide_categories_p1', 'guide_categories_p2', 'guide_categories_p3'],
  },
  {
    slug: 'why-top-5-is-fun',
    titleKey: 'guide_why_title',
    excerptKey: 'guide_why_excerpt',
    paragraphs: ['guide_why_p1', 'guide_why_p2', 'guide_why_p3'],
  },
  {
    slug: 'common-mistakes',
    titleKey: 'guide_mistakes_title',
    excerptKey: 'guide_mistakes_excerpt',
    paragraphs: ['guide_mistakes_p1', 'guide_mistakes_p2', 'guide_mistakes_p3'],
  },
  {
    slug: 'best-first-guesses',
    titleKey: 'guide_first_title',
    excerptKey: 'guide_first_excerpt',
    paragraphs: ['guide_first_p1', 'guide_first_p2', 'guide_first_p3'],
  },
  {
    slug: 'thinking-in-lists',
    titleKey: 'guide_lists_title',
    excerptKey: 'guide_lists_excerpt',
    paragraphs: ['guide_lists_p1', 'guide_lists_p2', 'guide_lists_p3'],
  },
  {
    slug: 'how-answers-are-validated',
    titleKey: 'guide_validation_title',
    excerptKey: 'guide_validation_excerpt',
    paragraphs: ['guide_validation_p1', 'guide_validation_p2', 'guide_validation_p3'],
  },
  {
    slug: 'language-and-accents',
    titleKey: 'guide_accents_title',
    excerptKey: 'guide_accents_excerpt',
    paragraphs: ['guide_accents_p1', 'guide_accents_p2', 'guide_accents_p3'],
  },
  {
    slug: 'play-on-mobile',
    titleKey: 'guide_mobile_title',
    excerptKey: 'guide_mobile_excerpt',
    paragraphs: ['guide_mobile_p1', 'guide_mobile_p2', 'guide_mobile_p3'],
  },
  {
    slug: 'level-progression',
    titleKey: 'guide_progress_title',
    excerptKey: 'guide_progress_excerpt',
    paragraphs: ['guide_progress_p1', 'guide_progress_p2', 'guide_progress_p3'],
  },
  {
    slug: 'daily-routine',
    titleKey: 'guide_routine_title',
    excerptKey: 'guide_routine_excerpt',
    paragraphs: ['guide_routine_p1', 'guide_routine_p2', 'guide_routine_p3'],
  },
  {
    slug: 'guessing-with-friends',
    titleKey: 'guide_friends_title',
    excerptKey: 'guide_friends_excerpt',
    paragraphs: ['guide_friends_p1', 'guide_friends_p2', 'guide_friends_p3'],
  },
  {
    slug: 'what-to-do-when-stuck',
    titleKey: 'guide_stuck_title',
    excerptKey: 'guide_stuck_excerpt',
    paragraphs: ['guide_stuck_p1', 'guide_stuck_p2', 'guide_stuck_p3'],
  },
  {
    slug: 'suggest-a-theme',
    titleKey: 'guide_suggest_title',
    excerptKey: 'guide_suggest_excerpt',
    paragraphs: ['guide_suggest_p1', 'guide_suggest_p2', 'guide_suggest_p3'],
  },
];
